/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { GetTraceabilityRequestsStatsQueryResponse } from "../types/GetTraceabilityRequestsStats.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getTraceabilityRequestsStatsQueryKey = () =>
  [{ url: "/v1/traceability-requests/stats" }] as const

export type GetTraceabilityRequestsStatsQueryKey = ReturnType<
  typeof getTraceabilityRequestsStatsQueryKey
>

/**
 * @summary Get traceability requests stats
 * {@link /v1/traceability-requests/stats}
 */
export async function getTraceabilityRequestsStats(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetTraceabilityRequestsStatsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/traceability-requests/stats`, ...requestConfig })
  return res
}

export function getTraceabilityRequestsStatsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getTraceabilityRequestsStatsQueryKey()
  return queryOptions<
    ResponseConfig<GetTraceabilityRequestsStatsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetTraceabilityRequestsStatsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTraceabilityRequestsStats({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get traceability requests stats
 * {@link /v1/traceability-requests/stats}
 */
export function useGetTraceabilityRequestsStats<
  TData = ResponseConfig<GetTraceabilityRequestsStatsQueryResponse>,
  TQueryData = ResponseConfig<GetTraceabilityRequestsStatsQueryResponse>,
  TQueryKey extends QueryKey = GetTraceabilityRequestsStatsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTraceabilityRequestsStatsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getTraceabilityRequestsStatsQueryKey()

  const query = useQuery(
    {
      ...getTraceabilityRequestsStatsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
